import { Injectable } from '@angular/core';
import { EnvironmentService, Environment } from '@galaxy/core';

@Injectable({ providedIn: 'root' })
export class HostService {
  private _host: string;
  private _httpsHost: string;

  constructor(private environmentService: EnvironmentService) {}

  host(): string {
    if (this._host) {
      return this._host;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this._host = 'wsp-admin-center-api.vendasta-local.com';
        break;
      case Environment.TEST:
        this._host = '';
        break;
      case Environment.DEMO:
        this._host = 'websitepro-demo.apigateway.co';
        break;
      case Environment.PROD:
        this._host = 'websitepro-prod.apigateway.co';
        break;
    }
    return this._host;
  }

  httpsHost(): string {
    if (this._httpsHost) {
      return this._httpsHost;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this._httpsHost = 'wsp-admin-center.vendasta-local.com';
        break;
      case Environment.TEST:
        this._httpsHost = '';
        break;
      case Environment.DEMO:
        this._httpsHost = 'websitepro-demo.apigateway.co';
        break;
      case Environment.PROD:
        this._httpsHost = 'websitepro-prod.apigateway.co';
        break;
    }
    return this._httpsHost;
  }

  hostWithScheme(): string {
    const scheme = this.environmentService.getEnvironment() === Environment.LOCAL ? 'http://' : 'https://';
    return scheme + this.host();
  }

  httpsHostWithScheme(): string {
    const scheme = this.environmentService.getEnvironment() === Environment.LOCAL ? 'http://' : 'https://';
    return scheme + this.httpsHost();
  }
}
